// soundManager.js
var SoundManager = pc.createScript('soundManager');

// initialize code called once per entity
SoundManager.prototype.initialize = function() {
    SoundManager.instance = this;
};

// update code called every frame
SoundManager.prototype.playSound = function (soundName) {

    if (PlayerManager.instance.userData.gameSound) {
        if (GameManager.instance.adsSoundMute) {
            this.entity.sound.play(soundName);
        }

    }
};

SoundManager.prototype.stopSound = function (soundName) {

    if (PlayerManager.instance.userData.gameSound) {
        if (GameManager.instance.adsSoundMute) {
            this.entity.sound.stop(soundName);
        }
    }
};

SoundManager.prototype.pauseSound = function (soundName) {

    if (PlayerManager.instance.userData.gameSound) {
        this.entity.sound.pause();
    }
};

SoundManager.prototype.resumeSound = function (soundName) {

    if (PlayerManager.instance.userData.gameSound) {
        this.entity.sound.resume();
    }
};

